var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M15.37 4.89A8 8 0 11.63 11.12a8 8 0 0114.74-6.23zM8 1.79a6.22 6.22 0 100 12.43A6.22 6.22 0 008 1.78zm.89 2.66V7.1h2.66V8.9H8.9v2.66H7.11V8.9H4.45V7.1H7.1V4.45H8.9z", "fill-rule": "nonzero" } }] }, name: "plus-circle", theme: "outlined" };
export {
  e as default
};
